import { z } from 'zod';
import { DocGroup } from '../enums.js';
export const documentMetaInput = z.object({
    projectId: z.string().optional().nullable(),
    clientId: z.string().optional().nullable(),
    courseId: z.string().optional().nullable(),
    docGroup: z.nativeEnum(DocGroup).default(DocGroup.ALTRO),
    version: z.string().max(40).optional().nullable(),
    visibility: z.enum(['team', 'client', 'private']).default('team'),
});
//# sourceMappingURL=document.js.map